 <template>
    <div class="container">
        <div class="flex flex-wrap justify-center content-center items-center">
            <div class="w-full">
                <v-alert type="error" outlined dense v-if="user.vehicles.length === 0 ">You have not registered a vehicle.  The parking hang tag is not valid and will not be distributed until a vehicle is registered.  Please do so now.</v-alert>

                <v-form :action="appURL + '/userpermit'" method="POST" ref="form" v-model="formvalid">
                    <input type="hidden" :value="csrfToken" name="_token">
                    <input type="hidden" :value="user.is_student_resident_or_employee" name="employee_or_student">
                    <v-card raised>
                        <v-card-title>UIS Parking Permit Application for {{ user.full_name }}</v-card-title>
                        <v-card-subtitle>Applicant Information</v-card-subtitle>
                        <v-card-text>
                            <div class="px-2">
                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                    <div class="w-full md:w-1/3 px-2">
                                        <v-text-field readonly outlined v-model="user.full_name" name="full_name" prepend-icon="person" label="Name"></v-text-field>
                                    </div>
                                    <div class="w-full md:w-1/3 px-2">
                                        <v-text-field persistent-hint hint= "Please enter only digits, no spaces, no brackets." name="phone" :rules="[rules.phoneLength]" outlined v-model="form.phone" prepend-icon="phone" label="Phone"></v-text-field>
                                    </div>
                                    <div v-if ="user.is_student_resident_or_employee === 'E'" class="w-full md:w-1/3 px-2">
                                        <v-text-field persistent-hint hint= "Please provide your office location (e.g. HSB 115)so that we can deliver your parking hang tag." name="office" :rules="[rules.required]" outlined v-model="form.office" prepend-icon="work" label="Office"></v-text-field>
                                    </div>
                                </div>
                            </div>
                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-text>
                            <span class="text-lg inline-block bg-green-200 rounded-full px-3 py-1 font-semibold mr-2">Permit Information</span>
                            <div class="px-2">
                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                    <div class="w-full md:w-3/4 px-2 py-2">
                                        <v-radio-group name="permit_type" :rules="[rules.required]" v-model="form.permit_type">
                                            <template v-slot:label>
                                                <div>Please select your <strong>plan</strong>.</div>
                                            </template>
                                            <div v-for="permittype in permittypes" :key="permittype.permit_type_code">
                                                <v-radio @change="form.payment_type = ''" :value="permittype.permit_type_code">
                                                    <template v-slot:label>
                                                        <div>{{ permittype.description }}<strong class="success--text px-2">${{ permittype.permit_fee }}</strong></div>
                                                        <span v-if="permittype.description.includes('PERKS')" class="text-xs text-red-600"> Prior to purchase, Contact Parking Operations at 217-206-8502</span>
                                                    </template>
                                                </v-radio>
                                            </div>
                                        </v-radio-group>
                                    </div>
                                </div>
                            </div>
                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-text>
                            <div class="px-2">
                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                    <span class="text-lg inline-block bg-green-200 rounded-full px-3 py-1 font-semibold mr-2">Payment Information</span>
                                    <div class="w-full px-2">
                                        <v-card-text>
                                            <div class="px-2">
                                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                                    <div class="w-full md:w-1/2 px-2">
                                                        <v-radio-group name="payment_type" :rules="[rules.required]" v-model="form.payment_type">
                                                            <v-radio value="Credit"
                                                                    :disabled="form.permit_type.slice(-2) === 'PD' && form.permit_type !== ''"
                                                            >
                                                                <template v-slot:label>
                                                                    <div> <v-icon>credit_card</v-icon>Credit/Debit Card</div>
                                                                </template>
                                                            </v-radio>

                                                            <v-radio v-if="user.people && user.people.payroll_deduction === 'Y'" value="Payroll"
                                                                    :disabled="form.permit_type.slice(-2) !== 'PD'"
                                                            >
                                                                <template v-slot:label>
                                                                    <div> <v-icon>attach_money</v-icon>Payroll Deduction</div>
                                                                </template>
                                                            </v-radio>
                                                        </v-radio-group>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card-text>
                                    </div>
                                </div>
                            </div>
                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-text v-if="form.payment_type === 'Payroll'">
                            <div class="px-2">
                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                    <span class="text-lg inline-block bg-green-200 rounded-full px-3 py-1 font-semibold mr-2">Payroll Form</span>
                                    <div v-if="user.currentpayrolldeduction === null" class="w-full px-2">
                                        <p>I hereby authorize a pre-tax Parking deduction for the Springfield Campus at the University of Illinois in the amount certified as the correct rate of deduction to be withheld from my pay in accordance with the State Salary and Annuity Withholding Act. To end parking deductions, the Parking Operations must receive a valid cancellation form and the Hang Tag associated with the individual requesting the payroll deduction termination.</p>
                                        <v-card-text>
                                            <div class="px-2">
                                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                                    <div class="w-full md:w-1/2 px-2">
                                                        <v-select name="payment_time" :rules="[rules.required]" v-model="form.payment_time" :items="payrollPaymentItems" prepend-icon="palette" label="You are paid?"></v-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card-text>
                                    </div>
                                    <div v-else class="w-full px-2 my-3">
                                        <v-alert dense text type="info">You already have enrolled for payroll deduction for a parking permit .
                                            To end parking deductions, the Parking Operations must receive a valid cancellation form and the Hang Tag associated with the individual requesting the payroll deduction termination.Please use Credit/Debit options to buy a new permit. </v-alert>
                                    </div>
                                </div>
                            </div>
                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-text>
                            <div class="px-2">
                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                    <span class="text-lg inline-block bg-green-200 rounded-full px-3 py-1 font-semibold mr-2">Important Notice</span>
                                    <div class="w-full ">
                                        <v-card-text>
                                            <div class="px-2">
                                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                                    <div class="w-full px-2">
                                                        <span>Please review the Parking Rules and Motor Vehicle Regulations on our website to learn all you need to know about parking on the UIS campus.</span>
                                                    </div>
                                                </div>
                                                <br>
                                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                                    <div class="w-full px-2">
                                                    <span>All vehicles operated or parked on University property by full-time, part-time and temporary faculty, students, staff and employees of the University of Illinois Springfield must display a valid Parking Hang Tag at all times.  The Parking Hang Tag is obtained by registering the vehicle with the Parking Operations Office through this online purchase.  Once the online purchase is complete, the UIS Parking Permit Receipt must be presented to the Parking Operations Office for registrant to obtain their respective Parking Hang Tag. </span>
                                                    </div>
                                                </div>
                                                <br>
                                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                                    <div class="w-full px-2">
                                                        <span>Individuals who work at the University of Illinois Springfield, but who are paid by another entity, must purchase a valid Parking Hang Tag to park on University property.</span>
                                                    </div>
                                                </div>
                                                <br>
                                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                                    <div class="w-full px-2">
                                                        <span>Any UIS student, faculty, or staff member, may register only his/her vehicle(s), or the vehicle of a member of his/her immediate family, including any relative domiciled at the individual’s residence.  Each individual UIS student, faculty or staff member, that has a vehicle on campus, will be required to obtain a Parking Hang Tag at the full price for their own vehicle.</span>
                                                    </div>
                                                </div>
                                                <br>
                                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                                    <div class="w-full px-2">
                                                        <span>Registration of a vehicle is not complete until the Parking Hang Tag issued, is hung on the rear view mirror or displayed visibly in the front windshield of the motor vehicle with the parking hang tag numbers facing outward and legible for inspection. Individuals that only have a motorcycle, will be responsible for one parking hang tag and required to display it on the motorcycle.  Should the individual have both a vehicle and a motorcycle, they should only purchase one parking hang tag but will be responsible for displaying the single parking hang tag on the vehicle or motorcycle when parked on campus.A second parking hang tag may be purchased if one chooses to park their vehicle and motorcycle on campus simultaneously.</span>
                                                    </div>
                                                </div>
                                                <br>
                                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                                    <div class="w-full px-2">
                                                        <span>Registrant is responsible for all violations issued on any vehicle displaying this Parking Hang Tag. No registrant may transfer, loan, duplicate, trade, nor sell their respective Parking Hang Tag.</span>
                                                    </div>
                                                </div>

                                                <br>
                                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                                    <div class="w-full px-2">
                                                        <span>The University is authorized to impose sanctions for violations of the university vehicle parking regulations, withdraw motor vehicle privileges and/or cause the removal of vehicles at the operator’s or owner’s expense as provided in the university vehicle parking regulations, refer the matter to internal disciplinary action,  impose a violation penalty, or any combination of the above.</span>
                                                    </div>
                                                </div>
                                                <br>
                                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                                    <div class="w-full px-2">
                                                        <span>Only students who drop out of the University within the first two weeks of the semester or employees who resign or are terminated within two weeks of their employment start date are eligible to receive a full refund of the cost for the Parking Hang Tag.  After the end of the second week of class, or employment, no hang tag refunds will be given.  The Parking Hang Tag must be returned when applying for a refund. A refund can only be requested within the semester that the parking hang tag is purchased.
                                                            In addition to the refund policy above, only those student, staff and faculty having purchased an annual hang tag, may request a refund* for ½ the price of the annual hang tag cost. In order to receive this refund, the student, staff or faculty must return their parking hang tag to and complete a refund application with the Parking Operation’s office before January 1st.  Parking hang tag refunds are not available after January 1st. *Not available to faculty and staff utilizing payroll deduction for the purchase of their parking hang tag.
                                                        </span>
                                                    </div>
                                                </div>
                                                <br>
                                                <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                                    <div class="w-full px-2">
                                                        <span>I understand that the vehicle(s) can be parked on campus parking lots ONLY if it displays a valid
                                                            Parking Hang Tag.  I understand that the acceptance of this purchase application for a Parking Hang
                                                            Tag and issuance of a Parking Hang Tag creates a contractual obligation on my part to abide by the
                                                            Parking Rules and Motor Vehicle Regulations of the University of Illinois Springfield.  I authorize the University of
                                                            Illinois Springfield to withhold a sufficient amount from my paycheck to cover obligations which
                                                            may be due or become due to UIS whether by contract, lease, under it rules and regulations, or
                                                            otherwise.
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card-text>
                                    </div>
                                </div>
                            </div>
                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn type="submit" :disabled="user.currentpayrolldeduction && form.payment_type === 'Payroll'"
                                :loading="loadingUpdate" color="success"
                            > I accept the terms and conditions of this contract
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
                <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
                    {{ snackText }}
                    <v-btn text @click="snack = false">Close</v-btn>
                </v-snackbar>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                disabledCredit: false,
                disabledPayroll: false,
                appURL: process.env.MIX_APP_URL,
                csrfToken: document.querySelector('meta[name="csrf-token"]').content,
                loadingUpdate: false,
                formvalid: true,
                snack: false,
                snackColor: '',
                snackText: '',
                rules: {
                    required: value => !!value || "Required.",
                    phoneLength: v => (v || "").length === 10 || "Minimum 10 characters",
                },
                form: {
                    full_name: this.user.full_name,
                    phone: '',
                    office: '',
                    permit_type: '',
                    payment_type: '',
                    payment_time: '',
                },
                payrollPaymentItems: [
                    { text: 'Bi-Weekly', value: 'bi-weekly'},
                    { text: 'Monthly', value: 'monthly'}
                ],
            }
        },
        created() {
        },
        props: {
            permittypes: {
                required: true,
                type: Object,
            },
            user: {
                required: true,
                type: Object,
            },
            dropdowns: {
                require: true,
                type: Object
            },

        },
        methods: {
            onClickSubmit: function(form) {
                if(!this.$refs.form.validate() )
                {
                    this.snack = true;
                    this.snackColor = 'error';
                    this.snackText = 'There are errors in the form!';
                } else {
                    this.loadingUpdate = true;
                    axios.post(this.appURL + '/api/userpermit', {
                        'full_name' : form.full_name,
                        'phone' : form.phone,
                        'office': form.office,
                        'permit_type' : form.permit_type,
                        'payment_type' : form.payment_type,
                        'payment_time': form.payment_time,
                    }).then((response) => {
                        if(response.status === 200)
                        {
                            this.snack = true;
                            this.snackColor = 'success';
                            this.snackText = 'Successfully Submitted';
                            window.location.href = this.appURL;
                        }
                        else {
                            this.snack = true;
                            this.snackColor = 'error';
                            this.snackText = 'Oops! Something went wrong!';
                        }
                        this.loadingUpdate = false;
                    }).catch(error => {
                        this.snack = true;
                        this.snackColor = 'error';
                        this.snackText = 'Oops! Something went wrong!';
                        this.loadingUpdate = false;
                    });
                }
            },
        }
    }
</script>
